import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9a9 3 0 1 0 18 0a9 3 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M3 9a9 9 0 0 0 18 0","key":"svg-1"}]]

/**
 * IconHemisphere
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItaGVtaXNwaGVyZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMyA5YTkgMyAwIDEgMCAxOCAwYTkgMyAwIDEgMCAtMTggMCIgLz4KICA8cGF0aCBkPSJNMyA5YTkgOSAwIDAgMCAxOCAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/hemisphere
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconHemisphere = createReactComponent('outline', 'hemisphere', 'Hemisphere', __iconNode);

export default IconHemisphere;